export default __webpack_public_path__ + "static/media/downIcon.873042af.svg";